import React from "react";
import { motion } from "framer-motion";
import { PRODUCTS } from "@/lib/site";
import { Overline, FadeUp } from "./Motion";

export const ProductGrid = () => {
  return (
    <section id="flooring" className="bg-bone py-24 lg:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-16">
          <Overline>The flooring collection</Overline>
          <FadeUp>
            <h2 className="mt-5 font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight text-royal-deep leading-none">
              Anything in the <span className="italic text-royal">flooring segment.</span>
            </h2>
          </FadeUp>
          <FadeUp delay={0.1}>
            <p className="mt-6 text-muted-foreground lg:text-lg">
              Laminate, engineered, solid wood, bamboo, deck, vinyl & LVT, sports systems and
              carpets &mdash; benchmarked to the world&rsquo;s highest standards.
            </p>
          </FadeUp>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-12 auto-rows-[220px] lg:auto-rows-[240px] gap-4 lg:gap-6">
          {PRODUCTS.map((p, i) => (
            <motion.div
              key={p.name}
              data-testid={`product-${p.name.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              initial={{ opacity: 0, scale: 0.96 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1], delay: (i % 4) * 0.08 }}
              className={`group relative overflow-hidden rounded-lg ${p.span}`}
            >
              <img
                src={p.img}
                alt={`${p.name} — ${p.tag}, premium flooring by Fascinated by Floors`}
                className="absolute inset-0 h-full w-full object-cover transition-transform duration-700 ease-out group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-royal-deep/25 group-hover:bg-royal-deep/50 transition-colors duration-500" />
              <div className="absolute inset-0 p-6 flex flex-col justify-end">
                <div className="translate-y-2 group-hover:translate-y-0 transition-transform duration-500">
                  <span className="text-[11px] tracking-[0.2em] uppercase text-white/70">{p.tag}</span>
                  <h3 className="font-display text-2xl lg:text-3xl text-white leading-tight">{p.name}</h3>
                </div>
              </div>
              <div className="absolute top-5 left-5 h-2 w-2 rounded-full bg-terracotta opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
